import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { RecurrencyService } from 'app/services/recurrency/recurrency.service';
import { EditRecurrencyComponent } from './edit-recurrency/edit-recurrency.component';

@Component({
  selector: 'app-recurrencies',
  templateUrl: './recurrencies.component.html',
  styleUrls: ['./recurrencies.component.css']
})
export class RecurrenciesComponent implements OnInit {

  title = 'Recurrencias';
  recurrency: any;
  recurrencies: any[];
  displayedColumns: string[] = ['description', 'days', 'actions'];
  recurrenciesDataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator) recurrenciesPaginator: MatPaginator;
  constructor(private recurrencyService: RecurrencyService,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    
  }

  async ngAfterViewInit(){
    await this.getRecurrencies();
  }

  openForm(){
    const dialogRef = this.dialog.open(EditRecurrencyComponent, {
      data: {
        recurrency: this.recurrency
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('closed recurrency dialog!');
      this.ngOnInit();
    })
  }

  async getRecurrencies(){
    this.recurrencies = await this.recurrencyService.getRecurrencies();
    this.recurrenciesDataSource = new MatTableDataSource<any>(this.recurrencies);
    this.recurrenciesDataSource.paginator = this.recurrenciesPaginator;
    console.log('recurrencies loaded!');
  }

}
